module.exports = __webpack_public_path__ + "static/media/wm_bg_sleep.8567a216.webp";